import React from 'react'

const NoMatch = () => {
    return <div className="h3">Page not found...</div>
}

export default NoMatch
